var main = (function($) {
 
  function init() {


	/**
	* Mark links as external or local
	* ================
	*/
	$('a').each(function() {
		var a = new RegExp('/' + window.location.host + '/');
	    if (!a.test(this.href)) {
	      	// This is an external link
	    	$(this).addClass("is-external-link");
	    } else {
	    	$(this).addClass("is-local-link");
	    }
	});



  	// TOGGLE SEARCH
	jQuery(".toggle-search").click(function () {
		jQuery('.header-search-form-container').slideToggle("slow");
	});

    // TOGGLE RESPONSIVE MENU
    $(function(){
      $('.menu-toggle').click(function(evt) {
        evt.preventDefault();
        $('header.responsive-nav').toggleClass('open');
        $('.mobile-navigation').toggle();
      });

      $('li.lang-item').click(function(evt) {
        var href = $(this).children('a').attr('href');
        window.location = href;
      });

      $('.submenu-toggle').click(function(evt) {
        evt.preventDefault();
        $(this).parent('li').toggleClass('open-submenu');
      });
    });



    // Track phone number link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
    $('a[href^="tel:"]').click(function(){

      var phonenumber = $( this ).attr( 'href' );

      ga('send', {
        hitType: 'event',
        eventCategory: 'Puhelinnumero',
        eventAction: 'click',
        eventLabel: phonenumber
      });

    });

    // Track mail address link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
    $('a[href^="mailto:"]').click(function(){

      var mailaddress = $( this ).attr( 'href' );

      ga('send', {
        hitType: 'event',
        eventCategory: 'Sähköpostiosoite',
        eventAction: 'click',
        eventLabel: mailaddress
      });

    });

    
  	
	// REPLACE ALL SVG IMAGES CONTAING CLASS SVG WITH INLINE SVG	
	jQuery('img.svg').each(function(){
	    var $img = jQuery(this);
	    var imgID = $img.attr('id');
	    var imgClass = $img.attr('class');
	    var imgURL = $img.attr('src');

	    jQuery.get(imgURL, function(data) {
	        // Get the SVG tag, ignore the rest
	        var $svg = jQuery(data).find('svg');

	        // Add replaced image's ID to the new SVG
	        if(typeof imgID !== 'undefined') {
	            $svg = $svg.attr('id', imgID);
	        }
	        // Add replaced image's classes to the new SVG
	        if(typeof imgClass !== 'undefined') {
	            $svg = $svg.attr('class', imgClass+' replaced-svg');
	        }

	        // Remove any invalid XML tags as per http://validator.w3.org
	        $svg = $svg.removeAttr('xmlns:a');

	        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
	        if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
	            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
	        }

	        // Replace image with new SVG
	        $img.replaceWith($svg);

	    }, 'xml');
	});

	// DISABLE FEATURE ON CHROME: BUTTON STAYS FOCUSED AFTER CLICK 
	document.addEventListener('click', function(e) { 
		if(document.activeElement.toString() == '[object HTMLButtonElement]') { 
			document.activeElement.blur(); 
		} 
	});

	// SUB-NAVIGATION FIX FOR USING TABULATOR
    var siteNavigation = $('.main-menu-area li.menu-item-has-children ul.sub-menu');
    siteNavigation.find( 'a' ).on( 'focus blur', function() {
      $( this ).parents( 'ul' ).toggleClass( 'focus' );
    });

    // PRODUCT FILTERS
	$('.product-filters').on('click', 'li', function() {
	    $('.product-filters li.current').removeClass('current');
	    $(this).addClass('current');
	});

	var options = {
	   animationDuration: 0.5, // in seconds
	   filter: 'all', // Initial filter
	   callbacks: { 
	      onFilteringStart: function() { },
	      onFilteringEnd: function() { },
	      onShufflingStart: function() { },
	      onShufflingEnd: function() { },
	      onSortingStart: function() { },
	      onSortingEnd: function() { }
	   },
	   controlsSelector: '', // Selector for custom controls
	   delay: 0, // Transition delay in ms
	   delayMode: 'progressive', // 'progressive' or 'alternate'
	   easing: 'ease-out',
	   filterOutCss: { // Filtering out animation
	      opacity: 0,
	      transform: 'scale(0.5)'
	   },
	   filterInCss: { // Filtering in animation
	      opacity: 0,
	      transform: 'scale(1)'
	   },
	   layout: 'sameHeight', // See layouts
	   multifilterLogicalOperator: 'or',
	   selector: '.filtr-container',
	   setupControls: true // Should be false if controlsSelector is set 
	} 
	// You can override any of these options and then call...
	// var filterizd = $('.filtr-container').filterizr(options);
	// If you have already instantiated your Filterizr then call...
	// filterizd.filterizr('setOptions', options);

	if ($(".filtr-container")[0]) {
		var filterizd = $('.filtr-container').filterizr(options);
		filterizd.filterizr('setOptions', options);
	}

	$( '.accordion' ).click( function() {
		$(this).parents('h3').next('.accordion-content').toggle(); // Toggle the accordion content visibility
		$(this).attr('aria-expanded', function(i, attr) { // Change the button aria-expanded value
			return attr == 'true' ? 'false' : 'true';
		});
	});

	$('.filter-button').each(function() { // Filter buttons for syopatutkimukset-listing.php
		var filterId = $(this).attr('id');
		$('#' + filterId).click(function() {
			$('.filter-button').removeClass('active');
			$(this).addClass('active');
			$('.research-wrapper').show();
			$('.research-wrapper').not('#' + filterId + '-wrapper').hide();
		});
		$('#showall').click(function() {
			$('.research-wrapper').show();
		});
	});

  } // end of fuction init

  return {
    init: init
  };
}(jQuery));


var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);

if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    jQuery('.img-container img').each(function(){
        var t = jQuery(this),
            s = 'url(' + t.attr('src') + ')',
            p = t.parent(),
            d = jQuery('<div></div>');

        p.append(d);
        d.css({
            'height'                : t.parent().css('height'),
            'background-size'       : 'cover',
            'background-repeat'     : 'no-repeat',
            'background-position'   : '50% 20%',
            'background-image'      : s
        });
        t.hide();
    });
}